"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = require("gsap");
const THREE = __importStar(require("three"));
const EventDispatcher_1 = __importDefault(require("../EventDispatcher"));
class Chapter extends EventDispatcher_1.default {
    constructor() {
        super();
        this.key = '';
        this.text = '';
        this.textIdx = 0;
        this.textBlackEvent = { type: 'text-black' };
        this.textWhiteEvent = { type: 'text-white' };
        this.showTextEvent = { type: 'text-show', text: '' };
        this.hideTextEvent = { type: 'text-hide' };
        this.doneEvent = { type: 'done' };
        this.finishEvent = { type: 'finish' };
    }
    start() {
        throw new Error('상속이 필요');
    }
    stop(cb) {
        throw new Error('상속이 필요');
    }
    update(time) {
        throw new Error('상속이 필요');
    }
    dispatchDone(position, offset, color) {
        this.doneEvent.data = { position, offset, color };
        this.dispatchEvent(this.doneEvent);
    }
    dispatchFinish() {
        this.dispatchEvent(this.finishEvent);
    }
    dispatchTextBlack() {
        this.dispatchEvent(this.textBlackEvent);
    }
    dispatchTextWhite() {
        this.dispatchEvent(this.textWhiteEvent);
    }
    showText(delay = 0, color) {
        gsap_1.gsap.delayedCall(delay, () => {
            if (Array.isArray(this.text)) {
                this.dispatchEvent(this.hideTextEvent);
                this.showTextEvent.text = this.text[this.textIdx];
                this.textIdx += 1;
            }
            else {
                this.showTextEvent.text = this.text;
            }
            this.showTextEvent.color = color ? color : 'black';
            this.dispatchEvent(this.showTextEvent);
        });
    }
    hideText() {
        this.dispatchEvent(this.hideTextEvent);
    }
    done(delay = 0, position = new THREE.Vector3(), offset = new THREE.Vector3(), color = '') {
        gsap_1.gsap.delayedCall(delay, () => this.dispatchDone(position, offset, color));
    }
}
exports.default = Chapter;
